import { asApr } from "@silo/utils";
import { ReactNode } from "react";
import { getBorrowState, getBorrowStateColor } from "./utils";
import { classNames } from "../../utils/class-names";

interface BorrowTotalProps {
  hasBorrowRewards: boolean;
  totalBorrowApr: bigint;
  isBorrowAprFixed: boolean;
  ["data-cy"]?: string;
  className?: string;
}

export function BorrowTotal({
  hasBorrowRewards,
  totalBorrowApr,
  isBorrowAprFixed,
  ["data-cy"]: dataCy,
  className,
}: BorrowTotalProps): JSX.Element {
  return (
    <Root
      hasBorrowRewards={hasBorrowRewards}
      totalBorrowApr={totalBorrowApr}
      isBorrowAprFixed={isBorrowAprFixed}
      data-cy={dataCy}
      className={className}
    >
      <Value totalBorrowApr={totalBorrowApr} />

      {isBorrowAprFixed && <Fixed />}
    </Root>
  );
}

BorrowTotal.Root = Root;
BorrowTotal.Value = Value;
BorrowTotal.Fixed = Fixed;

interface RootProps {
  className?: string;
  hasBorrowRewards: boolean;
  totalBorrowApr: bigint;
  isBorrowAprFixed: boolean;
  ["data-cy"]?: string;
  children?: ReactNode;
}

function Root({
  children,
  className,
  hasBorrowRewards,
  totalBorrowApr,
  isBorrowAprFixed,
  ["data-cy"]: dataCy,
}: RootProps) {
  const borrowState = getBorrowState(hasBorrowRewards, totalBorrowApr);

  return (
    <dd
      data-cy={dataCy}
      className={classNames(
        "flex flex-col font-medium text-white",
        isBorrowAprFixed ? "text-amber-300" : "",
        getBorrowStateColor(borrowState),
        className
      )}
    >
      {children}
    </dd>
  );
}

interface ValueProps {
  className?: string;
  totalBorrowApr: bigint;
  dataCy?: string;
}

function Value({ className, totalBorrowApr, dataCy }: ValueProps) {
  return (
    <span
      className={classNames("font-mono text-2xl", className)}
      data-cy={dataCy}
    >
      {asApr(totalBorrowApr)}
    </span>
  );
}

interface FixedProps {
  className?: string;
}

function Fixed({ className }: FixedProps) {
  return <span className={className}>Fixed</span>;
}
